import { useState } from "react";
import { Star } from "lucide-react";

export function Stars({ value, size = "w-4 h-4", testId }) {
  return (
    <div className="flex items-center gap-0.5 text-[#C5A358]" data-testid={testId} aria-label={`${value} dari 5 bintang`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} className={`${size} ${n <= value ? "fill-current" : "text-[#D9CDB3]"}`} />
      ))}
    </div>
  );
}

export function StarPicker({ value, onChange }) {
  const [hover, setHover] = useState(0);
  const active = hover || value;
  const labels = ["", "Kurang", "Cukup", "Baik", "Sangat Baik", "Luar Biasa"];
  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-1" onMouseLeave={() => setHover(0)}>
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            type="button"
            data-testid={`review-star-${n}`}
            aria-label={`${n} bintang`}
            onMouseEnter={() => setHover(n)}
            onClick={() => onChange(n)}
            className="p-0.5 transition-transform hover:scale-110"
          >
            <Star className={`w-7 h-7 ${n <= active ? "fill-[#C5A358] text-[#C5A358]" : "text-[#D9CDB3]"}`} />
          </button>
        ))}
      </div>
      <span className="text-xs text-[#5E6D5B] min-w-[5rem]" data-testid="review-rating-label">{labels[active]}</span>
    </div>
  );
}
